import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Cell, Pie, PieChart as RechartsPieChart } from 'recharts';
import { palette } from '../../../theme/paletteV2';

export const NoDataOrLoadingState = ({
  loading,
  isAnimationActive,
}: {
  loading: boolean;
  isAnimationActive: boolean;
}) => {
  const data = [{ name: 'No data', value: 100, color: palette.background.grayLight }];

  const { t } = useTranslation();

  return loading ? (
    <div data-test="pie-chart-loading">
      <RechartsPieChart height={200} width={200}>
        <Pie
          data={data}
          opacity={0.5}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          outerRadius={100}
          innerRadius={50}
          stroke="none"
          isAnimationActive={isAnimationActive}
        >
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={entry.color}
              style={
                loading
                  ? {
                      animation: 'pulse-loading 2s ease-in-out infinite',
                    }
                  : undefined
              }
            />
          ))}
        </Pie>
      </RechartsPieChart>
    </div>
  ) : (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: 200,
        width: 245,
        gap: 0.5,
        mb: 3.5,
        textAlign: 'center',
      }}
    >
      <Typography variant="body1Bold">{t('No data')}</Typography>
      <Typography variant="body1" color={palette.text.secondary}>
        {t('Try adjusting filters or date range to see the results.')}
      </Typography>
    </Box>
  );
};
